export enum QueryKeys {
  GetBridgeUsers = 'getBridgeUsers',
  GetBridgeUser = 'getBridgeUser',
  GetProfile = 'getProfile',
  GetProperties = 'getProperties',
}
